import React, { useState, useEffect, useRef } from "react";
import SignaturePad from 'signature_pad';
import { useParams } from "react-router-dom";
import Airtable from "airtable";
import logo from "./logo-sigal_3.png";
import html2pdf from 'html2pdf.js';
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import styled from "styled-components";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "./OrderDetails.css";
import {uploadBunny} from './bunnynet.js';


const sizes = {
	"S/39/4": { shoes: "39", adult: "S", child: "4" },
	"M/40/6": { shoes: "40", adult: "M", child: "6" },
	"L/41/8": { shoes: "41", adult: "L", child: "8" },
	"XL/42/10": { shoes: "42", adult: "XL", child: "10" },
	"2XL/43/12": { shoes: "43", adult: "2XL", child: "12" },
	"3XL/44/14": { shoes: "44", adult: "3XL", child: "14" },
	"4XL/45/16": { shoes: "45", adult: "4XL", child: "16" },
	"5XL/46/18": { shoes: "46", adult: "5XL", child: "18" },
	36: { shoes: "36" },
	"36-5": { shoes: "36.5" },
	37: { shoes: "37" },
	"37-5": { shoes: "37.5" },
	38: { shoes: "38" },
	"38-5": { shoes: "38.5" },
	"39-5": { shoes: "39.5" },
	"40-5": { shoes: "40.5" },
	"41-5": { shoes: "41.5" },
	"42-5": { shoes: "42.5" },
	"43-5": { shoes: "43.5" },
	"44-5": { shoes: "44.5" },
	"45-5": { shoes: "45.5" },
	"46-5": { shoes: "46.5" },
	47: { shoes: "47" },
	"47-5": { shoes: "47.5" },
	48: { shoes: "48" },
	"One Size": { shoes: "One Size", adult: "One Size", child: "One Size" },
};

const InfoDiv = (props) => {
	return (
		<div>
			{props.name}:{" "}
			<span style={{ textDecoration: "underline", whiteSpace: "pre" }}>
				{!props.val || props.val === ""
					? " ".repeat(props.placeTimes ?? 50)
					: props.val}
			</span>
		</div>
	);
};

const InfoSpan = (props) => {
	return (
		<span style={{ ...props.style }}>
			{props.name}:{" "}
			<span
				style={{
					textDecoration: "underline",
					whiteSpace: "pre",
					fontWeight: "normal",
				}}
			>
				{!props.val || props.val === ""
					? " ".repeat(props.placeTimes ?? 50)
					: props.val}
			</span>
		</span>
	);
};

const TopPart = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	flex-direction: column;
`;

const Header = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;

	@media screen and (max-width: 40em) {
		flex-direction: column-reverse;
		margin-bottom: 30px;
	}
`;

const BottomPart = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
	page-break-inside: avoid;
	break-inside: avoid;

	& .part1 {
		display: flex;
		flex-direction: column;
		max-width: 50%;
	}

	& .part2 {
		display: flex;
		flex-direction: column;
		max-width: 60%;
		gap: 8px;
		page-break-inside: avoid;
		break-inside: avoid;
	}

	@media screen and (max-width: 40em) {
		padding-bottom: 24px;
		& .part1 {
			max-width: none;
		}

		& .part2 {
			max-width: none;
		}
	}
`;

function useInput({ type }) {
	const [value, setValue] = useState("");
	const input = (
		<input
			value={value}
			onChange={(e) => setValue(e.target.value)}
			type={type}
		/>
	);
	return [value, input];
}

const OrderDetails = (props) => {
	const [orderDetails, setOrderDetails] = useState({});
	const [orderItems, setOrderItems] = useState([]);
	const routerParams = useParams();
	const [approverName, approverNameInput] = useInput({ type: "text" });
	const [approverId, approverIdInput] = useInput({ type: "text" });
	const [signature, setSignature] = useState(null);
	const [signatureTimestamp, setSignatureTimestamp] = useState(null);
	const signatureCanvasRef = useRef(null);
	const [signaturePad, setSignaturePad] = useState(null);
	const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

	const base = new Airtable({
		apiKey:
			"patBXQgJPv4W41ktc.c7c4725c447b5fbef08fcd945de907f7ff20eb53ee6213c0f546fc811def4547",
	}).base(routerParams.base || "appZ1xuAo89gyeDRW");

	const initializeSignaturePad = (canvas) => {
		if (!canvas) return null;
		return new SignaturePad(canvas, {
			minWidth: 1,
			maxWidth: 2.5,
			penColor: 'rgb(0, 0, 0)',
			velocityFilterWeight: 0.7
		});
	};

	useEffect(() => {
		// Initialize signature pad
		if (signatureCanvasRef.current) {
			const canvas = signatureCanvasRef.current;

			// Only initialize if not already initialized
			if (!signaturePad) {
				const pad = initializeSignaturePad(canvas);
				if (pad) setSignaturePad(pad);

				// Handle both mouse and touch events
				const handleStart = () => {
					if (!signaturePad) {
						const newPad = initializeSignaturePad(canvas);
						if (newPad) setSignaturePad(newPad);
					}
				};

				canvas.addEventListener('mousedown', handleStart);
				canvas.addEventListener('touchstart', handleStart);

				return () => {
					canvas.removeEventListener('mousedown', handleStart);
					canvas.removeEventListener('touchstart', handleStart);
					if (signaturePad) {
						signaturePad.off();
					}
				};
			}
		}
	}, [signatureCanvasRef, signaturePad]);

	useEffect(() => {
		base("הזמנות").find(routerParams.id, function (err, record) {
			if (err) {
				setOrderDetails({ error: "הזמנה לא קיימת במערכת" });
				console.error(err);
				return;
			}

			// if (record.fields.needsAdminApproval === 1) {
			// 	setOrderDetails({ error: "הזמנה ממתינה לאישור מנהל" });
			// 	console.error(record.fields.needsAdminApproval);
			// 	return;
			// }
			setOrderDetails(record.fields);
		});
	}, [routerParams.id]);

	useEffect(() => {
		let newItems = [];
		base("פריטי הזמנות")
			.select({
				view: "API",
				filterByFormula: `{הזמנה} = '${orderDetails["מס הזמנה"]}'`,
			})
			.eachPage(
				function page(records, fetchNextPage) {
					const fieldsM = records.map((rec) => rec.fields);
					newItems = [...newItems, ...fieldsM];

					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						setOrderItems({ error: "חלה שגיאה בקריאת הנתונים" });
						return;
					}

					setOrderItems(newItems);
				}
			);
	}, [orderDetails]);

	useEffect(() => {
		// Load the signature_pad library dynamically
		if (signatureCanvasRef.current) {
			import('signature_pad').then((SignaturePad) => {
				const pad = new SignaturePad.default(signatureCanvasRef.current, {
					backgroundColor: 'rgba(255, 255, 255, 0.9)',
					penColor: 'green'
				});
				setSignaturePad(pad);
			});
		}
	}, [signatureCanvasRef]);

	const clearSignature = () => {
		if (signaturePad) {
			signaturePad.clear();
		}
		if (signatureCanvasRef.current && !signaturePad) {
			const canvas = signatureCanvasRef.current;
			const ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);
		}
		setSignature(null);
		setSignatureTimestamp(null);
	};

	const saveSignature = async () => {
		// Try to initialize pad if it doesn't exist
		if (!signaturePad && signatureCanvasRef.current) {
			const pad = initializeSignaturePad(signatureCanvasRef.current);
			if (pad) setSignaturePad(pad);
		}

		// Check if we have a valid signature
		if (signaturePad && !signaturePad.isEmpty()) {
			const timestamp = new Date().toLocaleString('he-IL', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false
			});

			// Add timestamp to the signature canvas
			const canvas = signatureCanvasRef.current;
			const ctx = canvas.getContext('2d');
			ctx.font = '10px Arial';
			ctx.fillStyle = '#666';
			ctx.fillText(timestamp, 5, canvas.height - 5);

			const dataUrl = signaturePad.toDataURL('image/png');
			setSignature(dataUrl);
			setSignatureTimestamp(timestamp);
			return true;
		}

		return false;
	};

	const getItemSizes = (item) => {
		let type = "shoes";
		let itemType =
			item.rawType && item.rawType !== "" ? item.rawType : item.type[0];
		switch (itemType) {
			case "בוגרים":
				type = "adult";
				break;
			case "הדפסים":
				type = "adult";
				break;
			case "ילדים":
				type = "child";
				break;
			case "נעליים":
				type = "shoes";
				break;
			default:
				type = "shoes";
				break;
		}
		const itemSizes = Object.keys(sizes)
			.filter((size) => item[size] && item[size] !== 0)
			.map((size, idx) => {
				return (
					<React.Fragment key={size}>
						{idx > 0 && <span> | </span>}
						<InfoSpan name={sizes[size][type]} val={item[size] + ""} />
					</React.Fragment>
				);
			});

		return itemSizes;
	};

	const isGoodId = (id) => {
		id = String(id).trim();
		if (id.length > 9 || isNaN(id)) return false;
		id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
		return (
			Array.from(id, Number).reduce((counter, digit, i) => {
				const step = digit * ((i % 2) + 1);
				return counter + (step > 9 ? step - 9 : step);
			}) %
				10 ===
			0
		);
	};

	const generatePDF = async () => {
		// Try to save signature if it doesn't exist
		if (!signature) {
			const saved = await saveSignature();
			if (!saved) {
				alert("נא לחתום לפני אישור ההזמנה");
				return false;
			}
		}

		const orderElement = document.getElementById("orderForPdf");
		if (!orderElement) {
			alert("שגיאה ביצירת המסמך");
			return false;
		}

		try {
			setIsGeneratingPdf(true);
			// Create a simple container for PDF content
			const pdfContent = document.createElement('div');
			pdfContent.style.width = '270mm'; // A4 width
			pdfContent.style.minHeight = '450mm'; // A4 height
			pdfContent.style.height = 'fit-content'; // A4 height
			pdfContent.style.padding = '10px';
			pdfContent.style.backgroundColor = '#ffffff';
			pdfContent.style.direction = 'rtl';
			// Clone the element so we can modify it without affecting the original
			const tempElement = orderElement.cloneNode(true);

			// Convert inputs to text
			tempElement.querySelectorAll('input').forEach(input => {
				const span = document.createElement('span');
				span.style.fontWeight = 'bold';
				span.textContent = input.value;
				input.parentNode.replaceChild(span, input);
			});

			// Hide all buttons
			tempElement.querySelectorAll('button').forEach(button => {
				button.style.display = 'none';
			});

			// Convert signature canvas to image if signature exists
			if (signature) {
				const canvas = tempElement.querySelector('canvas');
				if (canvas) {
					const img = document.createElement('img');
					img.src = signature;
					img.style.width = '180px';
					img.style.height = '80px';
					img.style.border = '1px solid #ddd';
					canvas.parentNode.replaceChild(img, canvas);
				}
			}

			// Ensure the signature section stays together
			const signatureSection = tempElement.querySelector('.part2');
			if (signatureSection) {
				signatureSection.style.pageBreakInside = 'avoid';
				signatureSection.style.breakInside = 'avoid';
				signatureSection.style.position = 'relative';
				signatureSection.style.zIndex = '1';
			}

			// Create signature footer for each page
			const signatureFooter = document.createElement('div');
			signatureFooter.style.position = 'fixed';
			signatureFooter.style.top = '0px';
			signatureFooter.style.left = '20%';
			signatureFooter.style.fontSize = '12px';
			signatureFooter.style.color = '#666';
			signatureFooter.style.direction = 'ltr';
			signatureFooter.style.textAlign = 'left';
			signatureFooter.style.borderTop = '1px solid #ddd';
			signatureFooter.style.paddingTop = '5px';
			signatureFooter.style.width = '50%';
			signatureFooter.innerHTML = `
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<div>
						<div>חתימה דיגיטלית: ${signature.slice(-32)}</div>
						<div>שעת חתימה: ${signatureTimestamp}</div>
					</div>
					<img src="${signature}" alt="חתימה" style="width: 100px; height: 45px; border: 1px solid #ddd" />
				</div>
			`;

			pdfContent.innerHTML = tempElement.outerHTML;
			pdfContent.appendChild(signatureFooter);

			// Append the container to the body
			document.body.appendChild(pdfContent);

			// Configure basic PDF options
			const options = {
				margin: [10, 10, 10, 10], // top, right, bottom, left - extra bottom margin for footer
				filename: `Order_${orderDetails["מס הזמנה"] || ''}.pdf`,
				html2canvas: { 
					scale: 2,
					useCORS: true, // Enable cross-origin image loading
					logging: true,
					letterRendering: true
				},
				jsPDF: { 
					unit: 'mm', 
					format: 'a4', 
					orientation: 'landscape',
					compression: true
				}
			};

			// Generate PDF and handle upload
			const basePdf = html2pdf().set(options).from(pdfContent);
			
			// Get binary PDF data and convert to base64
			const bunnyUrl = await new Promise((resolve, reject) => {
				basePdf.outputPdf('datauristring').then(async (pdfDataUri) => {
					try {
						// Extract base64 data from data URI
						const base64Data = pdfDataUri.split(',')[1];
						

						// Upload to BunnyNet
						const url = await uploadBunny(
							base64Data,
							`${orderDetails["מס הזמנה"]}/Order_${orderDetails["מס הזמנה"]}_${new Date().toLocaleString('he-IL').replace(/[ .:,]/g, "-")}.pdf`
						);
						resolve(url);
					} catch (error) {
						console.error('Error handling PDF upload:', error);
						reject(error);
					}
				});
			});

			console.log("URL:", bunnyUrl);

			// Save PDF for download
			// basePdf.save();

			// Clean up
			document.body.removeChild(pdfContent);
			setIsGeneratingPdf(false);
			return bunnyUrl;
		} catch (error) {
			console.error('Error generating PDF:', error);
			alert("שגיאה ביצירת המסמך");
			return null;
		}
	};

	const approveOrder = async () => {
		if (approverName.length < 2 || !approverName.includes(" ")) {
			alert("שם מלא לא תקין");
			return;
		}
		if (approverId.length === 0 || !isGoodId(approverId)) {
			alert("ת״ז לא תקינה");
			return;
		}
		if (!signature) {
			alert("נא לחתום לפני אישור ההזמנה");
			return;
		}

		// if (!window.confirm(
		// 		"האם אתם בטוחים שהפרטים שהזנתם תקינים? לא ניתן לשנות פרטים אלו לאחר אישור ההזמנה"
		// 	)
		// )
		// 	return;

		// Generate PDF first
		const pdfGenerated = await generatePDF();
		if (!pdfGenerated) return;

		base("הזמנות").update(
			[
				{
					id: routerParams.id,
					fields: {
						"אישור הזמנה לקוח": true,
						"שם מאשר הזמנה": approverName,
						"תז לקוח מאשר": approverId,
						"קבצים מצורפים": [{url: pdfGenerated}],
					},
				},
			],
			function (err, records) {
				if (err) {
					console.error(err);
					return;
				}

				window.alert("ההזמנה אושרה ונשמרה במערכת!\nתודה רבה, סיגל בגדי עבודה");
				window.location.reload();
			}
		);
	};

	return (
		<div
			style={{
				fontFamily: "Assistant, sans-serif",
				color: "#804c9e",
				fontWeight: "bold",
				padding: "20px",
				width: "100%",
				height: "100vh",
				display: "flex",
				flexDirection: "column",
			}}
			id="orderForPdf"
		>
			<TopPart>
				<Header>
					<div style={{ display: "flex", flexDirection: "column" }}>
						<span>
							<span style={{ fontSize: "26px" }}>הזמנה</span> מס׳:{" "}
							{orderDetails["מס הזמנה"]}
						</span>
						<InfoDiv
							name="תאריך"
							val={new Date(orderDetails["תאריך הזמנה"]).toLocaleDateString()}
						/>
						<InfoDiv name="סוכן" val={orderDetails["agentName"]} />
					</div>
					<div style={{ textAlign: "center" }}>
						<div>
							תמנע 7 חולון 5881307 | טל' 03-5580668 | פקס 03-5591101
							<br />
							ח.פ 513830638 | www.sigal-ba.co.il
						</div>
						<br />
					</div>
					<img width="300px" alt="logo" src={logo} />
				</Header>
				<div
					style={{
						display: "flex",
						justifyContent: "space-evenly",
						gap: "8px",
						flexWrap: "wrap",
					}}
				>
					<InfoDiv
						name="לכבוד"
						val={orderDetails["clientName"]?.replaceAll('"', "")}
					/>
					<InfoDiv name="כתובת" val={orderDetails["כתובת לקוח"]} />
					<InfoDiv name="ח״פ/ע״מ" val={orderDetails["חפ"]} />
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "space-evenly",
						gap: "8px",
						flexWrap: "wrap",
					}}
				>
					<InfoDiv name="איש קשר" val={orderDetails["contactName"]} />
					<InfoDiv name="טלפון" val={orderDetails["לקוח טלפון"]} />
					<InfoDiv name="טלפון נוסף" val={orderDetails["איש קשר נוסף טלפון"]} />
					<InfoDiv name="אימייל" val={orderDetails["מייל לקוח"]} />
				</div>
			</TopPart>
			<div style={{ flexGrow: "1", padding: "20px" }}>
				<Table style={{ border: "1px solid black" }}>
					<Thead>
						<Tr style={{ minHeight: "80px" }}>
							<Th>פריט</Th>
							<Th>צבע</Th>
							<Th>הדפסה/רקמה</Th>
							<Th>
								<InfoSpan name="מידה" val="כמות" />
							</Th>
							<Th>כמות</Th>
							<Th>מחיר יח׳</Th>
							<Th>סה״כ</Th>
						</Tr>
					</Thead>
					<Tbody>
						{orderItems.map((item, idx) => (
							<Tr key={idx}>
								<Td>{item["itemName"]}</Td>
								<Td>{item["צבע"]}</Td>
								<Td>
									<div>
										<div>{item["הערות"]}</div>
										<InfoSpan
											name="הדפסה?"
											val={item["הדפסה?"] ? "☑️" : "❌"}
										/>
										{"  "} - {"  "}
										<InfoSpan name="רקמה?" val={item["רקמה?"] ? "☑️" : "❌"} />
									</div>
								</Td>
								<Td>{getItemSizes(item)}</Td>
								<Td>{item["totalQuantity"]}</Td>
								<Td>{parseFloat(item["מחיר משוקלל"]).toFixed(1)}₪</Td>
								<Td>{item["סכום שורה משוקלל"].toFixed(1)}₪</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</div>
			<BottomPart className="pagebreak">
				<div className="part1">
					<InfoDiv name="הערות" val={orderDetails["הערות להזמנה"]} />
					<InfoDiv name="הערות אריזה" val={orderDetails["הערות אריזה"]} />
					<InfoDiv
						name="זמן אספקה"
						val={
							(orderDetails["זמן אספקה"] ? orderDetails["זמן אספקה"] : "") +
							(orderDetails["תאריך אספקה ספציפי"]
								? " - " + orderDetails["תאריך אספקה ספציפי"]
								: "")
						}
					/>
					<InfoDiv name="תנאי תשלום" val={orderDetails["תנאי תשלום"]} />
					<InfoDiv
						name="צורת תשלום"
						val={
							(orderDetails["אופן תשלום"] ? orderDetails["אופן תשלום"] : "") +
							(orderDetails["סכום מקדמה"]
								? " - " + orderDetails["סכום מקדמה"] + "₪"
								: "")
						}
					/>
					<InfoDiv
						name="לקוח חדש?"
						val={orderDetails["לקוח חדש"] ? "כן" : "לא"}
					/>
					<InfoDiv
						name="סוג גרפיקת לוגו"
						val={orderDetails["סוג גרפיקת לוגו"]}
					/>
					<InfoDiv name="סוג אריזה" val={orderDetails["סוג אריזה"]} />
				</div>
				<div className="part2">
					<div
						style={{
							border: "1px solid #804c9e",
							display: "flex",
							gap: "16px",
							flexWrap: "wrap",
							justifyContent: "space-evenly",
						}}
					>
						<InfoDiv
							name="הנחה"
							val={
								orderDetails["אחוזי הנחה להזמנה"] &&
								orderDetails["אחוזי הנחה להזמנה"] > 0
									? (orderDetails["אחוזי הנחה להזמנה"] * 100).toFixed(0) + "%"
									: ""
							}
						/>
						<InfoDiv
							name="סכום"
							val={
								orderDetails["סכום ההזמנה"]
									? orderDetails["סכום ההזמנה"].toFixed(1) + "₪"
									: ""
							}
						/>
						<InfoDiv
							name={"מע״מ " + orderDetails["taxPercent"] * 100 + "%"}
							val={
								orderDetails["מעמ"] ? orderDetails["מעמ"].toFixed(1) + "₪" : ""
							}
						/>
						<InfoDiv
							name="סה״כ לתשלום"
							val={
								orderDetails["סכום ההזמנה כולל מעמ"]
									? orderDetails["סכום ההזמנה כולל מעמ"].toFixed(0) + "₪"
									: ""
							}
						/>
					</div>
					<div
						style={{
							border: "1px solid #804c9e",
							padding: "8px",
						}}
					>
						אני החתום מטה/המאשר, ערב באופן אישי לפירעון מלא של סכום הזמנה זאת.
						חתימת ידי/ אישור ההזמנה מהווה הסכמה מוחלטת על טיב המוצר והמידות של
						הבגדים המופיעים בהזמנה זאת. לא ניתן יהיה להחליף או להחזיר סחורה לאחר
						שהודפסה. במידה והתקבלו צ’קים, הנני מתחייב באופן
						אישי לפירעונם המלא,
						שכן במידה והצ’קים לא יכובדו תהייה הזכות לחברתכם לתבוע אותי באופן
						אישי.

						<br/><br/>
						כדי לאשר את ההזמנה: מלאו את הפרטים שלכם, חתמו בקוביית החתימה, לחצו על "שמור חתימה" ואז לחצו על "אשר הזמנה"
						<div
							style={{
								display: "flex",
								flexWrap: "wrap",
								justifyContent: "space-evenly",
								gap: "16px",
								alignItems: "center",
							}}
						>
							<InfoDiv
								name="הזמנה אושרה?"
								val={orderDetails["אישור הזמנה לקוח"] ? "☑️" : "❌"}
							/>
							{orderDetails["needsAdminApproval"] === 1 ? (
								<>
									<h2 style={{ color: "red", fontWeight: 700 }}>
										ממתין לאישור מנהל
									</h2>
								</>
							) : orderDetails["אישור הזמנה לקוח"] ? (
								<>
									<InfoDiv name="שם מלא" val={orderDetails["שם מאשר הזמנה"]} />
									<InfoDiv name="ת״ז" val={orderDetails["תז לקוח מאשר"]} />
								</>
							) : (
								<>
									<label>
										שם מלא מאשר:
										{approverNameInput}
									</label>
									<label>
										ת״ז מאשר:
										{approverIdInput}
									</label>
									<div style={{ 
										padding: '10px', 
										marginBottom: '10px', 
										pageBreakInside: 'avoid', 
										breakInside: 'avoid',
										marginTop: '20px',
										position: 'relative',
										zIndex: 0
									}}>
										<label>חתימה:</label>
										<div>
											{signature ? (
												<div>
												<img src={signature} alt="חתימה" style={{ width: '180px', height: '80px', border: '1px solid #ddd' }} />
												<div style={{ fontSize: '12px', color: '#666', marginTop: '5px', direction: 'ltr', textAlign: 'left' }}>
													חתימה דיגיטלית: {signature.slice(-32)}
													<br />
													שעת חתימה: {signatureTimestamp}
												</div>
											</div>
											) : (
												<canvas 
													ref={signatureCanvasRef} 
													width="300" 
													height="127.5"
													style={{ border: '1px solid #ddd', background: '#fff' }}
												></canvas>
											)}
										</div>
										{!isGeneratingPdf && !signature && ( // Only show buttons when not generating PDF and no signature exists
											<div style={{ marginTop: '5px' }}>
												<button
													onClick={clearSignature}
													style={{ marginRight: '10px' }}
												>
													נקה חתימה
												</button>
												<button
													onClick={saveSignature}
												>
													שמור חתימה
												</button>
											</div>
										)}
									</div>
									<button style={{background: '#804c9e', color: '#fff', fontSize: '16px', padding: '10px 20px'}} onClick={(e) => approveOrder()}>אשר הזמנה</button>
								</>
							)}
						</div>
					</div>
				</div>
			</BottomPart>
			{Object.keys(orderDetails).length === 0 && (
				<div
					style={{
						position: "absolute",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					טוען, אנא המתינו...
				</div>
			)}

			{orderDetails["error"] && (
				<div
					style={{
						position: "absolute",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					{orderDetails["error"]}
				</div>
			)}
		</div>
	);
};



export default OrderDetails;
